export default (value) => value.replace(/_/gi, ' ');
